module.exports = __webpack_public_path__ + "img/criteo.690957c9.png";